"use client";
import React, { useContext, useEffect, useRef, useState } from "react";
import Scrollbars from "react-custom-scrollbars";
import $ from "jquery";
import Icons from "./Icons/index";

import { Context } from "./contexts/AppContext";
import { getData } from "../lib/utils";

 
import GalleryManager from "./Gallery/GalleryManager";

const SideNav = () => {
  const [selectedFolderIndex, setSelectedFolderIndex] = useState(null);
  const [selectedFolder,setSelectedFolder]=useState(false)
  

  const { value } = useContext(Context);
 
  const [appState, setAppState] = value; 
  const [fullData, setFullData] = useState(appState.allFolderData);

    const [modalOpen, setModalOpen] = useState(appState.modalData);
 
  const mainDiv = useRef();
useEffect(() => {
  setModalOpen(appState.modalData); // modalOpen को अपडेट करें
}, [appState.modalData]);
 
  useEffect(() => {
    const adjustHeight = () => {
      $("#mainDiv").css({ height: window.innerHeight - $("#header").height() + "px" });
    };
    setTimeout(adjustHeight, 1000);
    adjustHeight();
  }, [fullData]);

  useEffect(() => { 
    console.log("USE EFFECT SIDE NAV ================= ",modalOpen?.folderUpdate);
    (async () => {
      const data = await getData("folder/folders");
      if (data.length>0) {        
        data.reverse() 
        console.log("DATA ======   ",data[0])
        setAppState((prevState) => {
          return { ...prevState, 
            currentFolderName:data[0].name,
            currentGalleryName:null,
            currentFolderId:0,
            allFolderData: data,
            modalData:{ ...prevState.modalData, folderUpdate: false}
          
          };
        });
        setSelectedFolder(true);
       
      }
      else if(data.length===0) { 
        
        localStorage.removeItem('appState')
      }
    })();
  }, [modalOpen?.folderUpdate]);

  const BASE_ITEMS = [
    { id: "newfolder", name: "AddFolder", txt: "New Folder" },
  ];

  return (
    <div className="relative min-h-screen">
   
      <div className="md:flex min-h-screen pb-8 border-2" id="mainDiv" ref={mainDiv}>
        <Sidebar BASE_ITEMS={BASE_ITEMS} fullData={fullData} setAppState={setAppState} appState={appState} />
        <ContentArea selectedFolder={selectedFolder} />
      </div>
    </div>
  );
};






//Side Bar component
const Sidebar = ({ BASE_ITEMS, fullData, setAppState, appState }) => (

 
  <div
    className="text-[0.9rem] font-semibold sidebar bg-[#eeeeee] text-black-800 w-[180px] space-y-6 py-7 absolute inset-y-0 left-0 transform -translate-x-full md:relative md:translate-x-0 transition duration-200 ease-in-out"
  >
    <nav>
      {BASE_ITEMS.map((item) => (
        <PanelListItem key={item.name} {...item} activePanel={appState.activePanel} />
      ))}
    </nav>
    <Scrollbars autoHeight autoHeightMin={100} autoHeightMax={520}>
      <div className="p-2"> 
      {appState.allFolderData.map((folder, index) => (
  <button
    key={"folderName" + index}
    id={index}
    type="button"
    className="flex gap-2 items-center"
    onClick={(e) => {
      const folderId = e.currentTarget.id; // Ensure we get the button's ID
      console.log(folderId);
      setAppState((prevState) => ({
        ...prevState,
        currentFolderName:folder.name,
        currentFolderId: folderId,
      }));
    }}
  >
    <Icons.Folder />
    {folder.name}
  </button>
))}

      </div>
    </Scrollbars>
  </div>
);







//CONTENT AREA COMPONENT
const ContentArea = ({ selectedFolder }) => (
  <div id="sideDetailedTray" className="relative w-full border-2 border-[#a5bce9] bg-white rounded-lg mt-2 mb-8 mx-2">
    {selectedFolder && <GalleryManager  />}
  </div>
);







//this new folder component
const PanelListItem = ({ name, txt, activePanel }) => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;  
 
  
  const Icon = Icons[name];
 const openFolderModal=()=>{
    
  setAppState((prevState) => {
      return { ...prevState, 
       

        modalData:{ ...prevState.modalData, type: "NewFolderModal", isOpen: true}};
    }); 
    
  }
  return (
    <button
      type="button"
      onClick={openFolderModal}
      className={`w-[150px] flex items-center justify-center font-medium text-sm border rounded-md p-2 gap-2 transition-all duration-500 ${
        name === activePanel ? "bg-white" : "bg-[#eeeeee]"
      }`}
    >
      <Icon />
      {txt}
    </button>
  );
};

export default SideNav;
